import { Badge, Card, Grid } from "@scuf/common";
import { useEffect, useState } from "react";
import AllVActualDomo from "../../components/Charts/Domo/AllVActualDomo";
import Compass from "../../components/Compass/Compass";
import DomoAngulos from "./components/DomoAngulos";
import DomoMasaStacker from "./components/DomoMasaStacker";
import MineralContainer from "./components/MineralContainer";
import PerfilGranulometrico from "./components/PerfilGranulometrico";
import TotalizadorConcentradoStaker from "./components/totalizadorConcentradoStaker";
import "./Domo.css";

const Domo = () => {
  //const [, setStateAll] = useState(null);
  const [staker, setStaker] = useState(0);
  const [reclaimer, setReclaimer] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [reclaimerVertical, setReclaimerVertical] = useState(0);
  const [isMounted, setIsMounted] = useState(true);

  /// All valor actual
  useEffect(() => {
    const fData = async () => {
      const data = await AllVActualDomo.getAll();

      // Hay que revisar esta linea de codigo, no sabemos que hace.
      //setStateAll(data);

      if (data && isMounted) {
        const stakerData = data.filter((x) => x.KPI === "Posición staker");
        const reclaimerData = data.filter(
          (x) => x.KPI === "Posición reclaimer"
        );

        if (stakerData.length === 0) {
          setStaker(0);
        } else {
          if (stakerData[0].Valor) {
            setStaker(stakerData[0].Valor);
          }
        }

        if (reclaimerData.length === 0) {
          setReclaimer(0);
        } else {
          if (reclaimerData[0].Valor) {
            setReclaimer(reclaimerData[0].Valor);
          }
        }
      }

      setTimeout(() => {
        if (isMounted) {
          fData();
        }
      }, 60000);

      return () => {
        setIsMounted(false);
      };
    };

    fData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Grid>
        <Grid.Row>
          <Grid.Column width={5} xsWidth={12} sWidth={12} lWidth={12}>
            <Card className="card-domo">
              <Card.Header title="DOMO" />
              <Card.Content>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Compass />
                    </Grid.Column>

                    <Grid.Column className="grid-position" width={4}>
                      <Card>
                        <Card.Header title={<Badge color="blue" empty />} />
                        <Card.Content>
                          <div className="content-position">
                            <div style={{ fontSize: "0.75rem" }}>
                              {" "}
                              POSICIÓN HORIZONTAL
                            </div>
                            <div>Staker</div>
                            <div>{staker + "°"}</div>
                          </div>
                        </Card.Content>
                      </Card>
                      <Card>
                        <Card.Header title={<Badge color="red" empty />} />
                        <Card.Content>
                          <div className="content-position">
                            <div style={{ fontSize: "0.75rem" }}>
                              {" "}
                              POSICIÓN HORIZONTAL
                            </div>
                            <div>Reclaimer</div>
                            <div>{reclaimer + "°"}</div>
                          </div>
                        </Card.Content>
                      </Card>
                      <Card>
                        <Card.Header title={<Badge color="green" empty />} />
                        <Card.Content>
                          <div className="content-position">
                            <div style={{ fontSize: "0.75rem" }}>
                              {" "}
                              POSICIÓN VERTICAL
                            </div>
                            <div>Reclaimer</div>
                            <div>{reclaimerVertical + "°"}</div>
                          </div>
                        </Card.Content>
                      </Card>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column width={7} xsWidth={12} sWidth={12} lWidth={12}>
            <MineralContainer />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={6} xsWidth={12} sWidth={12} lWidth={12}>
            <PerfilGranulometrico />
          </Grid.Column>
          <Grid.Column width={6} xsWidth={12} sWidth={12} lWidth={12}>
            <TotalizadorConcentradoStaker/>
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column width={6} xsWidth={12} sWidth={12} lWidth={12}>
            <DomoMasaStacker />
          </Grid.Column>
          <Grid.Column width={6} xsWidth={12} sWidth={12} lWidth={12}>
            <DomoAngulos />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default Domo;
